module.exports = __webpack_public_path__ + "img/9788960866652.40ee4c19.jpg";